import { useUserGroupPpgDaljab } from 'utils/hooks/useUserGroup'
import { MILKvKeys, useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'
import { useTogglesStore } from 'stores/toggles'

export const useCheckShowMenu = () => {
  const { data: featureFlagData } = useGetKeyPairValue(MILKvKeys.FeatureFlag)
  const { hasAccess: hasPpgDaljabAccess } = useUserGroupPpgDaljab()

  const shouldCheckingRolePpgDaljab =
    featureFlagData?.data?.enableSertifikasiPendidikCheckGroupRole
  const shouldShowPpgDaljabEntryPoint = shouldCheckingRolePpgDaljab
    ? hasPpgDaljabAccess
    : featureFlagData?.data?.enableSertifikasiPendidik

  const showPengelolaanKinerjaMenu = useTogglesStore(
    (state) => state.toggles?.['kinerja-enabled']
  )
  const showRefleksiPotensiMenu = useTogglesStore(
    (state) => state.toggles?.['refleksi-potensi-enabled']
  )
  const showRefleksiKompetensiMenu =
    featureFlagData?.data?.enableRefleksiKompetensiEntrypoint

  return {
    showSertifikasiPendidikMenu: shouldShowPpgDaljabEntryPoint,
    showPengelolaanKinerjaMenu,
    showRefleksiKompetensiMenu,
    showRefleksiPotensiMenu,
  }
}
